<template>
    <v-layout row>
      <v-spacer></v-spacer>
        <v-flex sm12 xs12>
          <v-container :style="(!isMobile()? 'max-width:1270px;':'')" class="pa-0">
          <v-app>
            <div style="display:none;">{{getWholesaleId}}</div>
            <v-toolbar v-if="getAgentTheme!=null" :fixed="isMobile()" :app="isMobile()" flat color="white">
                  <v-img v-if="!isMobile()" class="mt-4"
                  :src="getAgentTheme.logo.url" :max-height="getAgentTheme.logo.height" :max-width="getAgentTheme.logo.width" :aspect-ratio="getAgentTheme.logo.aspectRatio"></v-img>          
                  <img v-if="isMobile()&&agentTheme!=null" class="mt-2 mb-2"
                  :src="getAgentTheme.logo.url" :width="getAgentTheme.logo.mobileWidth" :height="getAgentTheme.logo.mobileHeight" :aspect-ratio="getAgentTheme.logo.mobileAspectRatio">
                  
                  <v-toolbar-title class="headline text-uppercase">
                    <span>{{getAgentTheme.logo.text}}<span style="display:none;">{{isIdle}}</span></span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        flat
                        v-on="on"
                      >
                        {{selLang}}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        v-for="(language, index) in languages"
                        :key="index"
                        @click="selectLanguage(language)"
                      >
                        <v-list-tile-title>{{ language }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>      
            </v-toolbar>
            <v-content>
              <router-view/>
            </v-content>
            <v-dialog v-model="showIdleAlertWindow" persistent max-width="450">
              <v-card>
                <v-card-title class="headline">Session has expired</v-card-title>
                <v-card-text>Flight price change frequently due to availability. We always want to show you the best fares available at any given time, so please refresh your flight results to get the very latest prices.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click="refreshSearch()">Refresh</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>  
          </v-app>
          </v-container>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>   
</template>

<script>
import AgentTheme from './agent_theme';
import ThemeService from './services/theme.service';

export default {
  name: 'App',
  components: {

  },
  data () {
    return {
      selLang:'EN',
      languages:['EN'],
      showIdleAlertWindow:false,
      allowCheckIdle:false,
      agentTheme: AgentTheme.getAgentTheme(),
      wholesaleId:"35",
    }
  },
  created(){
    this.$store.commit('initializeAppIdleness',false);
    let wid = this.$store.state.wholesaleId;
    this.wholesaleId = wid;
    
    setInterval(() => {
      if (this.wholesaleId==0) this.wholesaleId = this.$store.state.wholesaleId;
    }, 2000);
    
    setTimeout(()=>{
      this.allowCheckIdle = true;
    },2000);
  },
  updated(){
    if (this.isIdle&&this.allowCheckIdle){
      this.showIdleAlertWindow = true;
    }else {
      //this.showIdleAlertWindow = false;
    }
  },
  computed:{
    isIdle(){
      return this.$store.state.idleVue.isIdle;
    },
    getAgentTheme(){
      return AgentTheme.getAgentTheme(this.wholesaleId);
    },
    getWholesaleId(){
      return this.wholesaleId;
    },
  },  
  methods:{
    getWholesalerId(){
      ThemeService.getAgentWholesalerId().then ((rslt)=>{
        if (rslt!=null){
          let wholesaleId = rslt.data;
          if (rslt.data!=null||rslt.data!=""){
            this.agentTheme = AgentTheme.getAgentTheme(wholesaleId)
          }
        }
      });
    },
    refreshSearch(){
      this.showIdleAlertWindow = false;
      this.$router.push({name:'Refresher'})      
    },
    selectLanguage(l){
      this.selLang = l;
      this.$store.commit('selectLanguage',l);
    },
    isMobile(){
        return 'md,lg,xl'.indexOf(this.$vuetify.breakpoint.name)<0;
    }    
  }
}
</script>
